import Header from "../../Components/Header";
import { use, useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Form from "./Form";
import Headline from "./Headline";
import Swal from "sweetalert2";
import { Suspense, React, Fragment } from "react";
import ReactLoading from "react-loading";
import { Dialog, Transition } from "@headlessui/react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { sendPostRequest, sendGetRequest } from "../../Client";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import { Alert } from "flowbite-react";

export default function Home() {
  const location = useLocation();
  const navigate = useNavigate();
  const [strategies, setStrategies] = useState(["Strategy 1"]);

  const [companyID, setCompanyID] = useState(1);
  const [currency, setCurrency] = useState(1);
  const [editingSubmittedID, setEditingSubmittedID] = useState(null);

  const [calculation, setCalculation] = useState("");
  const [companyFee, setCompanyFee] = useState("");

  const [open, setOpen] = useState(false);

  function numberWithCommas(x) {
    if (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }

  function getCurrencySymbol(currency) {
    if (currency == 1) {
      return "£";
    } else if (currency == 2) {
      return "$";
    } else if (currency == 3) {
      return "€";
    } else if (currency == 4) {
      return "CZK";
    } else {
      return "£";
    }
  }

  function addStrategy() {
    const number = strategies.length + 1;
    setStrategies([...strategies, "Strategy " + number]);
  }

  const queryClient = useQueryClient();

  const notyf = new Notyf({
    position: {
      x: "right",
      y: "top",
    },
  });

  const addedNotyf = () => {
    notyf.success("Record added");
  };

  const initialDate = new Date().toISOString().split("T")[0];
  const initialDateArray = initialDate.split("-");

  const [inputs, setInputs] = useState({
    // second_advisor_split_from_advisor: "0",
    // date: "2024-10-08",
    // ultimate_owner: "7",
    // // bond_platform_no: "bond platform no",
    // // initial_total_value: "500000",
    // // agency: "AI",
    // // introducer: "4",
    // introducer_split_from_advisor: "0",
    // applied_to: "Whole Fee",
    // second_advisor: "3",
  });

  const [formInputs, setFormInputs] = useState({
    "Strategy 1--strategy_fee": "0.4",
    "Strategy 1--advisor_charge": "10",
    "Strategy 1--ongoing_charge": "1",
  });

  // getting the value of J12
  const [teamLeaderStrategy, setTeamLeaderStrategy] = useState(0);
  const [teamLeaderStrategyPercentage, setTeamLeaderStrategyPercentage] =
    useState(0);

  const getTeamLeaderStrategy = async (strategyID) => {
    if (!strategyID) return;
    const res = await sendGetRequest(
      "records/getTeamLeaderStrategy/" + strategyID,
      {}
    );
    setTeamLeaderStrategy(res?.teamLeaderStrategy[0]?.teamLeader);
    setTeamLeaderStrategyPercentage(
      res?.teamLeaderStrategy[0]?.teamLeaderPercentage
    );
  };

  useEffect(() => {
    getTeamLeaderStrategy(formInputs["Strategy 1--strategy_type"]);
  }, [formInputs["Strategy 1--strategy_type"]]);
  // end J12

  // getting the value of J13

  const [teamLeaderCompany, setTeamLeaderCompany] = useState(0);
  const [teamLeaderCompanyPercentage, setTeamLeaderCompanyPercentage] =
    useState(0);

  const getTeamLeaderCompany = async (companyID) => {
    if (!companyID) return;
    const res = await sendGetRequest(
      "records/getTeamLeaderCompany/" + companyID,
      {}
    );
    setTeamLeaderCompany(res?.teamLeaderCompany[0]?.teamLeader);
    setTeamLeaderCompanyPercentage(res?.teamLeaderCompany[0]?.paidAsTeamLeader);
  };

  useEffect(() => {
    getTeamLeaderCompany(companyID);
  }, [companyID]);

  // end J13

  // getting the value of J14
  // Advisor / Member Name -> does this advisor have a team leader -> if so we get the percentage

  const [teamLeaderAdvisor, setTeamLeaderAdvisor] = useState(0);
  const [teamLeaderAdvisorPercentage, setTeamLeaderAdvisorPercentage] =
    useState(0);

  const getTeamLeaderAdvisor = async (advisorID) => {
    if (!advisorID) return;
    const res = await sendGetRequest(
      "records/getTeamLeaderAdvisor/" + advisorID,
      {}
    );

    setTeamLeaderAdvisor(res?.teamLeaderAdvisor?.associatedTeamLeader);
    setTeamLeaderAdvisorPercentage(
      res?.teamLeaderAdvisor?.associatedTeamLeaderPercentage
    );
  };

  const getStrategiesTotalInvestedValue = () => {
    return strategies.reduce((sum, strategyName) => {
      const raw = formInputs[`${strategyName}--invested_value`];
      const val = parseFloat(raw);
      return sum + (isNaN(val) ? 0 : val);
    }, 0);
  };

  useEffect(() => {
    getTeamLeaderAdvisor(inputs.advisor);
  }, [inputs.advisor]);

  // end J14

  // Pre-fill form when navigating from Submitted Business Edit (state has raw + submittedID)
  const appliedEditRef = useRef(null);
  useEffect(() => {
    const state = location.state;
    if (state?.raw && state?.submittedID) {
      if (appliedEditRef.current !== state.submittedID) {
        const raw = state.raw;
        setInputs((prev) => ({ ...prev, ...(raw.inputs || {}) }));
        setFormInputs(raw.formInputs || {});
        setStrategies(
          Array.isArray(raw.strategies) ? [...raw.strategies] : ["Strategy 1"]
        );
        setCompanyID(raw.companyID ?? 1);
        setCurrency(raw.currency ?? 1);
        setEditingSubmittedID(state.submittedID);
        appliedEditRef.current = state.submittedID;
      }
    } else {
      appliedEditRef.current = null;
      setEditingSubmittedID(null);
    }
  }, [location.state]);

  const recordAdd = async (path, body) => {
    const res = await sendPostRequest(path, body);

    setCalculation(res.calculation);
    setCompanyFee(res.companyFee);
  };

  const { mutateAsync: doAddMutation } = useMutation({
    mutationFn: (data) => {
      return recordAdd(data.path, { ...data.body });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["companies"] });
    },
  });

  // confirm delete
  const areYouSure = (value) => {
    Swal.fire({
      title: "Are you sure you want to delete " + value + "?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "#de3333",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteStrategy(value);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  const deleteStrategy = (value) => {
    setStrategies((strategies) => {
      return strategies.filter((strategy) => strategy !== value);
    });
  };

  const addSubmittedBusiness = async () => {
    const requestBody = {
      recordID: calculation.ID,
      investedValue: calculation[0]?.invested_value,
      currency: calculation.currency,
      advisorDeclaredFee: calculation[0]?.ongoing_charge,
      strategyFee: calculation[0]?.strategy_fee,
      totalClientFeePaidFromProduct:
        (calculation[0]?.ongoing_charge * calculation[0]?.invested_value) / 100,
      advisorFee:
        (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) * 100,
      companyFee: companyFee,
      introducerPaidWholeFee: 0,
      introducerPaidAFs: calculation.introducerSplit,
      secondAdvisor: inputs.second_advisor_split_from_advisor,
      strategyLevel: teamLeaderStrategyPercentage,
      companyLevel: teamLeaderCompanyPercentage,
      advisorLevel: teamLeaderAdvisorPercentage,
      financeReference: formInputs["Strategy 1--finance_reference"],
      alternating_commission_cycle: inputs.alternating_commission_cycle,
      alternating_commission_months: inputs.alternating_commission_months,
      afterCompanyIntroducerAndCompany:
        (1 - companyFee / 100) *
        (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
        100,
      afterAdvisorIntroducerAndSecondAdvisor:
        (1 -
          inputs.introducer_split_from_advisor / 100 -
          inputs.second_advisor_split_from_advisor / 100) *
        (1 - companyFee / 100) *
        (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
        100,
      teamLeaderStrategyLevel:
        (teamLeaderStrategyPercentage / 100) * calculation[0]?.strategy_fee,
      teamLeaderCompanyLevel: (teamLeaderCompanyPercentage / 100) * companyFee,
      teamLeaderAdvisorLevel:
        (teamLeaderAdvisorPercentage / 100) *
        ((1 -
          inputs.introducer_split_from_advisor / 100 -
          inputs.second_advisor_split_from_advisor / 100) *
          (1 - companyFee / 100) *
          (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) *
        100,
      strategyNetFeePercentage:
        (calculation[0]?.strategy_fee - 0.1 * calculation[0]?.strategy_fee) *
        100,
      strategyNetFeeAmount:
        ((calculation[0]?.strategy_fee - 0.1 * calculation[0]?.strategy_fee) *
          calculation[0]?.invested_value) /
        100,
      companyNetFeePercentage:
        (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
          companyFee -
        0.1 *
          companyFee *
          (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee),
      companyNetFeeAmount:
        (((calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
          companyFee -
          0.1 *
            companyFee *
            (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) /
          100) *
        (calculation[0]?.invested_value / 100),
      IAFsPercentage:
        (1 - companyFee / 100) *
        (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
        inputs.introducer_split_from_advisor,
      IAFsAmount:
        ((1 - companyFee / 100) *
          (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
          (inputs.introducer_split_from_advisor / 100) *
          calculation[0]?.invested_value) /
        100,
      secondAdvisorPercentage:
        (1 - companyFee / 100) *
        (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
        inputs.second_advisor_split_from_advisor,
      secondAdvisorAmount:
        ((1 - companyFee / 100) *
          (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
          (inputs.second_advisor_split_from_advisor / 100) *
          calculation[0]?.invested_value) /
        100,
      teamLeaderStrategyPercentage:
        teamLeaderStrategyPercentage * calculation[0]?.strategy_fee,
      teamLeaderStrategyAmount:
        ((teamLeaderStrategyPercentage / 100) *
          calculation[0]?.strategy_fee *
          calculation[0]?.invested_value) /
        100,
      teamLeaderCompanyPercentage:
        (((100 * teamLeaderCompanyPercentage) / 100) *
          companyFee *
          (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) /
        100,
      teamLeaderCompanyAmount:
        ((((teamLeaderCompanyPercentage / 100) *
          companyFee *
          (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) /
          100) *
          calculation[0]?.invested_value) /
        100,
      teamLeaderAdvisorPercentage:
        teamLeaderAdvisorPercentage *
        ((1 -
          inputs.introducer_split_from_advisor / 100 -
          inputs.second_advisor_split_from_advisor / 100) *
          (1 - companyFee / 100) *
          (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) *
        100 *
        (((1 -
          inputs.introducer_split_from_advisor / 100 -
          inputs.second_advisor_split_from_advisor / 100) *
          (1 - companyFee / 100) *
          (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) /
          100),
      teamLeaderAdvisorAmount:
        (teamLeaderAdvisorPercentage / 100) *
        ((1 -
          inputs.introducer_split_from_advisor / 100 -
          inputs.second_advisor_split_from_advisor / 100) *
          (1 - companyFee / 100) *
          (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) *
        100 *
        (((1 -
          inputs.introducer_split_from_advisor / 100 -
          inputs.second_advisor_split_from_advisor / 100) *
          (1 - companyFee / 100) *
          (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) /
          100) *
        (calculation[0]?.invested_value / 100),
      advisorNetFeePayablePercentage:
        (calculation[0]?.ongoing_charge -
          calculation[0]?.strategy_fee -
          ((calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
            companyFee -
            0.1 *
              companyFee *
              (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) /
            100 -
          ((1 - companyFee / 100) *
            (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
            inputs.introducer_split_from_advisor) /
            100 -
          ((1 - companyFee / 100) *
            (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
            inputs.second_advisor_split_from_advisor) /
            100 +
          (100 * 0.1 * calculation[0]?.strategy_fee) / 100 -
          (100 * 0.1 * calculation[0]?.strategy_fee) / 100 -
          (100 *
            0.1 *
            companyFee *
            (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) /
            100 /
            100 -
          (100 *
            0.1 *
            ((1 -
              inputs.introducer_split_from_advisor / 100 -
              inputs.second_advisor_split_from_advisor / 100) *
              (1 - companyFee / 100) *
              (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) *
            100 *
            (((1 -
              inputs.introducer_split_from_advisor / 100 -
              inputs.second_advisor_split_from_advisor / 100) *
              (1 - companyFee / 100) *
              (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) /
              100)) /
            100) *
        100,
      advisorNetFeePayableAmount:
        ((calculation[0]?.ongoing_charge -
          calculation[0]?.strategy_fee -
          ((calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
            companyFee -
            0.1 *
              companyFee *
              (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) /
            100 -
          ((1 - companyFee / 100) *
            (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
            inputs.introducer_split_from_advisor) /
            100 -
          ((1 - companyFee / 100) *
            (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee) *
            inputs.second_advisor_split_from_advisor) /
            100 +
          (100 * 0.1 * calculation[0]?.strategy_fee) / 100 -
          (100 * 0.1 * calculation[0]?.strategy_fee) / 100 -
          (100 *
            0.1 *
            companyFee *
            (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) /
            100 /
            100 -
          (100 *
            0.1 *
            ((1 -
              inputs.introducer_split_from_advisor / 100 -
              inputs.second_advisor_split_from_advisor / 100) *
              (1 - companyFee / 100) *
              (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) *
            100 *
            (((1 -
              inputs.introducer_split_from_advisor / 100 -
              inputs.second_advisor_split_from_advisor / 100) *
              (1 - companyFee / 100) *
              (calculation[0]?.ongoing_charge - calculation[0]?.strategy_fee)) /
              100)) /
            100) *
          inputs.initial_total_value) /
        100,
      startDate: inputs.start_date,
      advisor: inputs.advisor,
      ...(editingSubmittedID != null && { submittedID: editingSubmittedID }),
      // Raw form data for pre-filling when editing this submitted business
      raw_form_data: {
        inputs: {
          ultimate_owner: inputs.ultimate_owner,
          start_date: inputs.start_date,
          product: inputs.product,
          product_provider: inputs.product_provider,
          forename: inputs.forename,
          surname: inputs.surname,
          client_ref: inputs.client_ref,
          bond_platform_no: inputs.bond_platform_no,
          initial_total_value: inputs.initial_total_value,
          exchange_rate: inputs.exchange_rate,
          advisor: inputs.advisor,
          agency: inputs.agency,
          introducer: inputs.introducer,
          introducer_split_from_advisor: inputs.introducer_split_from_advisor,
          second_advisor_split_from_advisor:
            inputs.second_advisor_split_from_advisor,
          second_advisor: inputs.second_advisor,
          applied_to: inputs.applied_to,
          alternating_commission_cycle: inputs.alternating_commission_cycle,
          alternating_commission_months: inputs.alternating_commission_months,
        },
        formInputs: { ...formInputs },
        strategies: [...strategies],
        companyID,
        currency,
      },
    };

    const isUpdate = editingSubmittedID != null;
    const endpoint = isUpdate
      ? "records/update/submitted"
      : "records/add/submitted";
    const res = await sendPostRequest(endpoint, requestBody);

    console.log("res", res);

    setOpen(false);
    setEditingSubmittedID(null);
    if (isUpdate) {
      notyf.success("Record updated");
    } else {
      addedNotyf();
    }
    console.log(res);
  };

  return (
    <>
      <Header />

      <Suspense fallback={<ReactLoading type={"spin"} color="green" />}>
        <section class="bg-gray-100 dark:bg-gray-900 py-3 sm:py-5">
          <div class="px-4 mx-auto max-w-screen-2xl lg:px-12 mb-12">
            <div class="relative overflow-hidden bg-white shadow-md dark:bg-gray-800 sm:rounded-lg">
              <div className="p-8">
                {/* <div>{JSON.stringify(formInputs)}</div> */}

                <form>
                  <Headline
                    companyID={companyID}
                    setCompanyID={setCompanyID}
                    inputs={inputs}
                    setInputs={setInputs}
                    setCurrency={setCurrency}
                    currency={currency}
                  />

                  {strategies.map((item, key) => (
                    <div key={key} className="py-4">
                      <Form
                        companyID={companyID}
                        item={item}
                        areYouSure={areYouSure}
                        setFormInputs={setFormInputs}
                        formInputs={formInputs}
                        inputs={inputs}
                      />
                    </div>
                  ))}

                  <div className="flex justify-end mb-4">
                    <button
                      type="button"
                      class="text-green-500 focus:ring-4 focus:ring-slate-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-600  dark:focus:ring-green-600 border border-green-500"
                      onClick={() => {
                        addStrategy();
                      }}
                    >
                      Add another strategy +
                    </button>
                  </div>

                  <hr></hr>

                  <button
                    type="button"
                    onClick={async () => {
                      if (!companyID) {
                        alert("Please enter a Company");
                        return;
                      }

                      if (!inputs.start_date) {
                        alert("Please enter a start date");
                        return;
                      }

                      if (!formInputs["Strategy 1--invested_value"]) {
                        alert("Please enter a value for Invested Value");
                        return;
                      }

                      if (!formInputs["Strategy 1--strategy_type"]) {
                        alert("Please select a strategy type");
                        return;
                      }

                      if (!formInputs["Strategy 1--strategy_fee"]) {
                        alert("Please enter a value for Strategy Fee %");
                        return;
                      }

                      if (!formInputs["Strategy 1--ongoing_charge"]) {
                        alert("Please enter a value for Ongoing % Charge");
                        return;
                      }

                      if (!formInputs["Strategy 1--advisor_charge"]) {
                        alert(
                          "Please enter a value for Split / Adviser Charge"
                        );
                        return;
                      }

                      const initialTotal = parseFloat(
                        inputs.initial_total_value || 0
                      );
                      const strategiesTotal = getStrategiesTotalInvestedValue();

                      const tolerance = 0.01;

                      if (isNaN(initialTotal)) {
                        alert(
                          "Please enter a valid number for Initial Total Value"
                        );
                        return;
                      }

                      if (
                        Math.abs(initialTotal - strategiesTotal) > tolerance
                      ) {
                        alert(
                          `Initial total value (${initialTotal.toLocaleString()}) must equal the sum of invested values from all strategies (${strategiesTotal.toLocaleString()}).`
                        );
                        return;
                      }

                      setOpen(true);

                      try {
                        const res = await doAddMutation({
                          path: "records/add",
                          body: {
                            companyID: companyID,
                            owner: inputs.ultimate_owner,
                            startDate: inputs.start_date,
                            product: inputs.product,
                            productProvider: inputs.product_provider,
                            forename: inputs.forename,
                            surname: inputs.surname,
                            clientRef: inputs.client_ref,
                            bondPlatformNo: inputs.bond_platform_no,
                            initial_total_value: inputs.initial_total_value,
                            exchangeRate: inputs.exchange_rate,
                            currency: currency,
                            advisor: inputs.advisor,
                            agency: inputs.agency,
                            introducer: inputs.introducer,
                            introducerSplit:
                              inputs.introducer_split_from_advisor,
                            secondAdvisorSplit:
                              inputs.second_advisor_split_from_advisor,
                            secondAdvisor: inputs.second_advisor,
                            appliedTo: inputs.applied_to,
                            formInputs: formInputs,
                          },
                        });
                      } catch (e) {
                        console.log(e);
                      }
                    }}
                    className="mt-10 text-white bg-green-500 hover:bg-green-600 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-slate-600 focus:outline-none dark:focus:ring-green-600"
                  >
                    {editingSubmittedID != null ? "Update" : "Submit"}
                  </button>
                </form>

                <Transition.Root show={open} as={Fragment}>
                  <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <Transition.Child
                      as={Fragment}
                      enter="ease-in-out duration-500"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in-out duration-500"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-hidden">
                      <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                          <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enterFrom="translate-x-full"
                            enterTo="translate-x-0"
                            leave="transform transition ease-in-out duration-500 sm:duration-700"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full"
                          >
                            <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                              <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
                                  <div className="flex items-center justify-between">
                                    <Dialog.Title className="text-lg font-medium text-gray-900"></Dialog.Title>
                                    <div className="ml-3 flex h-7 items-start w-full">
                                      <div className="flex flex-col w-full mt-2 mb-10">
                                        <div className="text-xl ml-2 mb-2">
                                          RecordID: {calculation?.ID}
                                        </div>

                                        {calculation[0]?.invested_value ? (
                                          <div className="w-full text-xs border-slate-200 border-2 rounded-2xl p-6 bg-slate-50">
                                            {/* <div className="text-xl">
                                              Strategy 1
                                            </div> */}
                                            <div className="mt-4 flex flex-row">
                                              <div className="w-4/5">
                                                Invested Value:{" "}
                                              </div>
                                              <div className="w-1/5">
                                                {getCurrencySymbol(
                                                  calculation[0]?.currency
                                                )}
                                                {numberWithCommas(
                                                  calculation[0]?.invested_value
                                                )}
                                              </div>
                                            </div>
                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Adviser Declared Fee:{" "}
                                              </div>
                                              <div className="w-1/5">
                                                {calculation[0]?.ongoing_charge}
                                                %
                                              </div>
                                            </div>
                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Strategy Fee
                                              </div>
                                              <div className="w-1/5">
                                                {calculation[0]?.strategy_fee *
                                                  100}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Total Client Fee paid from
                                                Product
                                              </div>
                                              <div className="w-1/5">
                                                £
                                                {numberWithCommas(
                                                  (calculation[0]
                                                    ?.ongoing_charge *
                                                    calculation[0]
                                                      ?.invested_value) /
                                                    100
                                                )}
                                              </div>
                                            </div>
                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Adviser Fee (Whole Fee)
                                              </div>
                                              <div className="w-1/5">
                                                {(calculation[0]
                                                  ?.ongoing_charge -
                                                  calculation[0]
                                                    ?.strategy_fee) *
                                                  100}
                                                %
                                              </div>
                                            </div>
                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Company fee
                                              </div>
                                              <div className="w-1/5">
                                                {companyFee}%
                                              </div>
                                            </div>
                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Introducer paid from Whole Fee
                                                (IFS)
                                              </div>
                                              <div className="w-1/5">0%</div>
                                            </div>
                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Introducer paid from AFs (IAFs)
                                              </div>
                                              <div className="w-1/5">
                                                {
                                                  inputs.introducer_split_from_advisor
                                                }
                                                %
                                              </div>
                                            </div>
                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                2nd adviser
                                              </div>
                                              <div className="w-1/5">
                                                {
                                                  inputs.second_advisor_split_from_advisor
                                                }
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Strategy level
                                              </div>
                                              <div className="w-1/5">
                                                {teamLeaderStrategyPercentage}%
                                              </div>
                                            </div>
                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Company level
                                              </div>
                                              <div className="w-1/5">
                                                {teamLeaderCompanyPercentage}%
                                              </div>
                                            </div>
                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Adviser level
                                              </div>
                                              <div className="w-1/5">
                                                {teamLeaderAdvisorPercentage}%
                                              </div>
                                            </div>

                                            <hr className="pt-2 mt-2"></hr>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Adviser Fee
                                              </div>
                                              <div className="w-1/5">
                                                {(calculation[0]
                                                  ?.ongoing_charge -
                                                  calculation[0]
                                                    ?.strategy_fee) *
                                                  100}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                After Company Introducer &
                                                Company
                                              </div>
                                              <div className="w-1/5">
                                                {(1 - companyFee / 100) *
                                                  (calculation[0]
                                                    ?.ongoing_charge -
                                                    calculation[0]
                                                      ?.strategy_fee) *
                                                  100}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                After Adviser Introducer & 2nd
                                                Adviser
                                              </div>
                                              <div className="w-1/5">
                                                {(
                                                  (1 -
                                                    inputs.introducer_split_from_advisor /
                                                      100 -
                                                    inputs.second_advisor_split_from_advisor /
                                                      100) *
                                                  (1 - companyFee / 100) *
                                                  (calculation[0]
                                                    ?.ongoing_charge -
                                                    calculation[0]
                                                      ?.strategy_fee) *
                                                  100
                                                ).toFixed(2)}
                                                %
                                              </div>
                                            </div>

                                            <hr className="pt-2 mt-2"></hr>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Team leader strategy level
                                              </div>
                                              <div className="w-1/5">
                                                {(
                                                  (teamLeaderStrategyPercentage /
                                                    100) *
                                                  calculation[0]?.strategy_fee
                                                ).toFixed(2)}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Team leader company level
                                              </div>
                                              <div className="w-1/5">
                                                {(
                                                  (teamLeaderCompanyPercentage /
                                                    100) *
                                                  companyFee
                                                ).toFixed(2)}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Team leader advisor level
                                              </div>
                                              <div className="w-1/5">
                                                {(
                                                  (teamLeaderAdvisorPercentage /
                                                    100) *
                                                  ((1 -
                                                    inputs.introducer_split_from_advisor /
                                                      100 -
                                                    inputs.second_advisor_split_from_advisor /
                                                      100) *
                                                    (1 - companyFee / 100) *
                                                    (calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee)) *
                                                  100
                                                ).toFixed(2)}
                                                %
                                              </div>
                                            </div>

                                            <hr className="pt-2 mt-2"></hr>

                                            <div className="flex flex-row font-bold text-green-700">
                                              <div className="w-4/5">
                                                STRATEGY NET FEE (after Team
                                                Leader)
                                              </div>
                                              <div className="w-1/5">
                                                {(
                                                  (calculation[0]
                                                    ?.strategy_fee -
                                                    0.1 *
                                                      calculation[0]
                                                        ?.strategy_fee) *
                                                  100
                                                ).toFixed(2)}
                                                %
                                              </div>
                                            </div>
                                            <div className="flex flex-row font-bold text-green-700">
                                              <div className="w-4/5">
                                                Amount
                                              </div>
                                              <div className="w-1/5">
                                                £
                                                {((calculation[0]
                                                  ?.strategy_fee -
                                                  0.1 *
                                                    calculation[0]
                                                      ?.strategy_fee) *
                                                  calculation[0]
                                                    ?.invested_value) /
                                                  100}
                                              </div>
                                            </div>

                                            <div className="flex flex-row font-bold text-green-700 mt-2">
                                              <div className="w-4/5">
                                                COMPANY NET FEE (after Team
                                                Leader)
                                              </div>
                                              <div className="w-1/5">
                                                {numberWithCommas(
                                                  (
                                                    calculation[0]
                                                      ?.ongoing_charge -
                                                    calculation[0]?.strategy_fee
                                                  ).toFixed(3) *
                                                    companyFee -
                                                    0.1 *
                                                      companyFee *
                                                      (
                                                        calculation[0]
                                                          ?.ongoing_charge -
                                                        calculation[0]
                                                          ?.strategy_fee
                                                      ).toFixed(3)
                                                )}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row font-bold text-green-700 mb-2">
                                              <div className="w-4/5">
                                                Amount
                                              </div>
                                              <div className="w-1/5">
                                                £
                                                {numberWithCommas(
                                                  (
                                                    (((calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee) *
                                                      companyFee -
                                                      0.1 *
                                                        companyFee *
                                                        (calculation[0]
                                                          ?.ongoing_charge -
                                                          calculation[0]
                                                            ?.strategy_fee)) /
                                                      100) *
                                                    (calculation[0]
                                                      ?.invested_value /
                                                      100)
                                                  ).toFixed(2)
                                                )}
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                IFS Introducer
                                              </div>
                                              <div className="w-1/5">
                                                {(calculation[0]
                                                  ?.ongoing_charge -
                                                  calculation[0]
                                                    ?.strategy_fee) *
                                                  0}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Amount
                                              </div>
                                              <div className="w-1/5">£0</div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                IAFs (Introducer)
                                              </div>
                                              <div className="w-1/5">
                                                {(
                                                  (1 - companyFee / 100) *
                                                  (calculation[0]
                                                    ?.ongoing_charge -
                                                    calculation[0]
                                                      ?.strategy_fee) *
                                                  inputs.introducer_split_from_advisor
                                                ).toFixed(1)}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Amount
                                              </div>
                                              <div className="w-1/5">
                                                £
                                                {(
                                                  ((1 - companyFee / 100) *
                                                    (calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee) *
                                                    (inputs.introducer_split_from_advisor /
                                                      100) *
                                                    calculation[0]
                                                      ?.invested_value) /
                                                  100
                                                ).toFixed(2)}
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                2nd Advisor
                                              </div>
                                              <div className="w-1/5">
                                                {(
                                                  (1 - companyFee / 100) *
                                                  (calculation[0]
                                                    ?.ongoing_charge -
                                                    calculation[0]
                                                      ?.strategy_fee) *
                                                  inputs.second_advisor_split_from_advisor
                                                ).toFixed(1)}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Amount
                                              </div>
                                              <div className="w-1/5">
                                                £
                                                {(
                                                  ((1 - companyFee / 100) *
                                                    (calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee) *
                                                    (inputs.second_advisor_split_from_advisor /
                                                      100) *
                                                    calculation[0]
                                                      ?.invested_value) /
                                                  100
                                                ).toFixed(2)}
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Team Leader (Strategy)
                                              </div>
                                              <div className="w-1/5">
                                                {(
                                                  teamLeaderStrategyPercentage *
                                                  calculation[0]?.strategy_fee
                                                ).toFixed(2)}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Amount
                                              </div>
                                              <div className="w-1/5">
                                                £
                                                {(
                                                  ((teamLeaderStrategyPercentage /
                                                    100) *
                                                    calculation[0]
                                                      ?.strategy_fee *
                                                    calculation[0]
                                                      ?.invested_value) /
                                                  100
                                                ).toFixed(2)}
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Team Leader (Company)
                                              </div>
                                              <div className="w-1/5">
                                                {(
                                                  (((100 *
                                                    teamLeaderCompanyPercentage) /
                                                    100) *
                                                    companyFee *
                                                    (calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee)) /
                                                  100
                                                ).toFixed(2)}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Amount
                                              </div>
                                              <div className="w-1/5">
                                                £
                                                {(
                                                  ((((teamLeaderCompanyPercentage /
                                                    100) *
                                                    companyFee *
                                                    (calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee)) /
                                                    100) *
                                                    calculation[0]
                                                      ?.invested_value) /
                                                  100
                                                ).toFixed(2)}
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Team Leader (Advisor)
                                              </div>
                                              <div className="w-1/5">
                                                {(
                                                  teamLeaderAdvisorPercentage *
                                                  ((1 -
                                                    inputs.introducer_split_from_advisor /
                                                      100 -
                                                    inputs.second_advisor_split_from_advisor /
                                                      100) *
                                                    (1 - companyFee / 100) *
                                                    (calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee)) *
                                                  100 *
                                                  (((1 -
                                                    inputs.introducer_split_from_advisor /
                                                      100 -
                                                    inputs.second_advisor_split_from_advisor /
                                                      100) *
                                                    (1 - companyFee / 100) *
                                                    (calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee)) /
                                                    100)
                                                ).toFixed(1)}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row">
                                              <div className="w-4/5">
                                                Amount
                                              </div>
                                              <div className="w-1/5">
                                                £
                                                {(
                                                  (teamLeaderAdvisorPercentage /
                                                    100) *
                                                  ((1 -
                                                    inputs.introducer_split_from_advisor /
                                                      100 -
                                                    inputs.second_advisor_split_from_advisor /
                                                      100) *
                                                    (1 - companyFee / 100) *
                                                    (calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee)) *
                                                  100 *
                                                  (((1 -
                                                    inputs.introducer_split_from_advisor /
                                                      100 -
                                                    inputs.second_advisor_split_from_advisor /
                                                      100) *
                                                    (1 - companyFee / 100) *
                                                    (calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee)) /
                                                    100) *
                                                  (calculation[0]
                                                    ?.invested_value /
                                                    100)
                                                ).toFixed(2)}
                                              </div>
                                            </div>

                                            <div className="flex flex-row mt-2">
                                              <div className="w-4/5 font-bold text-green-700">
                                                ADVISOR NET FEE PAYABLE
                                              </div>
                                              <div className="w-1/5 font-bold text-green-700">
                                                {(
                                                  (calculation[0]
                                                    ?.ongoing_charge -
                                                    calculation[0]
                                                      ?.strategy_fee -
                                                    ((calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee) *
                                                      companyFee -
                                                      0.1 *
                                                        companyFee *
                                                        (calculation[0]
                                                          ?.ongoing_charge -
                                                          calculation[0]
                                                            ?.strategy_fee)) /
                                                      100 -
                                                    ((1 - companyFee / 100) *
                                                      (calculation[0]
                                                        ?.ongoing_charge -
                                                        calculation[0]
                                                          ?.strategy_fee) *
                                                      inputs.introducer_split_from_advisor) /
                                                      100 -
                                                    ((1 - companyFee / 100) *
                                                      (calculation[0]
                                                        ?.ongoing_charge -
                                                        calculation[0]
                                                          ?.strategy_fee) *
                                                      inputs.second_advisor_split_from_advisor) /
                                                      100 +
                                                    (100 *
                                                      0.1 *
                                                      calculation[0]
                                                        ?.strategy_fee) /
                                                      100 -
                                                    (100 *
                                                      0.1 *
                                                      calculation[0]
                                                        ?.strategy_fee) /
                                                      100 -
                                                    (100 *
                                                      0.1 *
                                                      companyFee *
                                                      (calculation[0]
                                                        ?.ongoing_charge -
                                                        calculation[0]
                                                          ?.strategy_fee)) /
                                                      100 /
                                                      100 -
                                                    (100 *
                                                      0.1 *
                                                      ((1 -
                                                        inputs.introducer_split_from_advisor /
                                                          100 -
                                                        inputs.second_advisor_split_from_advisor /
                                                          100) *
                                                        (1 - companyFee / 100) *
                                                        (calculation[0]
                                                          ?.ongoing_charge -
                                                          calculation[0]
                                                            ?.strategy_fee)) *
                                                      100 *
                                                      (((1 -
                                                        inputs.introducer_split_from_advisor /
                                                          100 -
                                                        inputs.second_advisor_split_from_advisor /
                                                          100) *
                                                        (1 - companyFee / 100) *
                                                        (calculation[0]
                                                          ?.ongoing_charge -
                                                          calculation[0]
                                                            ?.strategy_fee)) /
                                                        100)) /
                                                      100) *
                                                  100
                                                ).toFixed(2)}
                                                %
                                              </div>
                                            </div>

                                            <div className="flex flex-row font-bold text-green-700">
                                              <div className="w-4/5">
                                                Amount
                                              </div>
                                              <div className="w-1/5">
                                                £
                                                {(
                                                  ((calculation[0]
                                                    ?.ongoing_charge -
                                                    calculation[0]
                                                      ?.strategy_fee -
                                                    ((calculation[0]
                                                      ?.ongoing_charge -
                                                      calculation[0]
                                                        ?.strategy_fee) *
                                                      companyFee -
                                                      0.1 *
                                                        companyFee *
                                                        (calculation[0]
                                                          ?.ongoing_charge -
                                                          calculation[0]
                                                            ?.strategy_fee)) /
                                                      100 -
                                                    ((1 - companyFee / 100) *
                                                      (calculation[0]
                                                        ?.ongoing_charge -
                                                        calculation[0]
                                                          ?.strategy_fee) *
                                                      inputs.introducer_split_from_advisor) /
                                                      100 -
                                                    ((1 - companyFee / 100) *
                                                      (calculation[0]
                                                        ?.ongoing_charge -
                                                        calculation[0]
                                                          ?.strategy_fee) *
                                                      inputs.second_advisor_split_from_advisor) /
                                                      100 +
                                                    (100 *
                                                      0.1 *
                                                      calculation[0]
                                                        ?.strategy_fee) /
                                                      100 -
                                                    (100 *
                                                      0.1 *
                                                      calculation[0]
                                                        ?.strategy_fee) /
                                                      100 -
                                                    (100 *
                                                      0.1 *
                                                      companyFee *
                                                      (calculation[0]
                                                        ?.ongoing_charge -
                                                        calculation[0]
                                                          ?.strategy_fee)) /
                                                      100 /
                                                      100 -
                                                    (100 *
                                                      0.1 *
                                                      ((1 -
                                                        inputs.introducer_split_from_advisor /
                                                          100 -
                                                        inputs.second_advisor_split_from_advisor /
                                                          100) *
                                                        (1 - companyFee / 100) *
                                                        (calculation[0]
                                                          ?.ongoing_charge -
                                                          calculation[0]
                                                            ?.strategy_fee)) *
                                                      100 *
                                                      (((1 -
                                                        inputs.introducer_split_from_advisor /
                                                          100 -
                                                        inputs.second_advisor_split_from_advisor /
                                                          100) *
                                                        (1 - companyFee / 100) *
                                                        (calculation[0]
                                                          ?.ongoing_charge -
                                                          calculation[0]
                                                            ?.strategy_fee)) /
                                                        100)) /
                                                      100) *
                                                    inputs.initial_total_value) /
                                                  100
                                                ).toFixed(2)}
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}
                                      </div>

                                      <button
                                        type="button"
                                        className="-m-2 p-2 text-gray-400 hover:text-gray-500"
                                        onClick={() => setOpen(false)}
                                      ></button>
                                    </div>
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  onClick={async () => {
                                    addSubmittedBusiness(companyFee);
                                  }}
                                  className=" text-white bg-green-500 hover:bg-green-600 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-slate-600 focus:outline-none dark:focus:ring-green-600 mx-10 w-24 flex justify-center"
                                >
                                  Confirm
                                </button>
                              </div>
                            </Dialog.Panel>
                          </Transition.Child>
                        </div>
                      </div>
                    </div>
                  </Dialog>
                </Transition.Root>
              </div>
            </div>
          </div>
        </section>
      </Suspense>
    </>
  );
}
